import { DsCompanyGroupInterface } from '../interfaces/ds-company-group.interface';

export class DsCompanyGroup {
  /**
   * Id of the group
   */
  public id?: number;

  /**
   * Optional company id
   */
  public companyId?: number;

  /**
   * Optional company name
   */
  public companyName?: string;

  /**
   * Name of the group
   */
  public name: string;

  /**
   * Whether the group has access to documents (GED)
   */
  public docRight: boolean;

  /**
   * Whether the group has access to monitoring (pins and forms)
   */
  public pinRight: boolean;

  /**
   * Optional list of linked user ids
   */
  public accounts?: number[];

  /**
   * Whether the group is checked
   */
  public checked?: boolean;

  /**
   * Creates an instance of DsCompanyGroup.
   *
   * @param jsonData the json data
   */
  constructor(jsonData: DsCompanyGroupInterface = {}) {
    this.id = jsonData.id || this.id;
    this.name = jsonData.name || this.name;
    this.companyId = jsonData.company_id || this.companyId;
    this.companyName = jsonData.company_name || this.companyName;
    this.docRight = !!jsonData.doc_right;
    this.pinRight = !!jsonData.pin_right;
  }
}
